module.exports = __webpack_public_path__ + "static/icon_number04-02b64e6e6c24855906ca25f41d9181f4.png";